import React from 'react';
import NoFilteredSuperProfiles from './NoFilteredSuperProfiles';
import SuperProfilesListEntry from './SuperProfilesListEntry';

const SuperProfilesList = ({ superProfiles, filter, setSuperProfileToDelete }) => {
  const superProfilesToDisplay = filter
    ? superProfiles.filter(
        (superProfile) =>
          superProfile.internalName.includes(filter) ||
          superProfile.publicTitle.includes(filter) ||
          superProfile.publicDescription.includes(filter),
      )
    : superProfiles;

  if (superProfilesToDisplay.length === 0) {
    return <NoFilteredSuperProfiles />;
  }

  return superProfilesToDisplay.map((superProfile) => {
    return <SuperProfilesListEntry superProfile={superProfile} setSuperProfileToDelete={setSuperProfileToDelete} />;
  });
};

export default SuperProfilesList;
